// extracted by mini-css-extract-plugin
module.exports = {"json":"JSONDisplay_json__30aIw","controls":"JSONDisplay_controls__28heq"};